export const characters = [
  {
    name: "Homer Simpson",
    image:
      "https://upload.wikimedia.org/wikipedia/en/0/02/Homer_Simpson_2006.png",
    quotes: ["D'oh!", "Mmm... donuts", "Kids are the best, Apu."],
  },
  {
    name: "Marge Simpson",
    image: "https://upload.wikimedia.org/wikipedia/en/0/0b/Marge_Simpson.png",
    quotes: [
      "Don't worry, Homer. That's your job.",
      "Police tried to arrest your husband.",
      "Just wait till you hear what happened.",
    ],
  },
  {
    name: "Bart Simpson",
    image:
      "https://upload.wikimedia.org/wikipedia/en/a/aa/Bart_Simpson_200px.png",
    quotes: [
      "Eat my shorts!",
      "I'm Bart Simpson, who the hell are you?",
      "Forget the true meaning of Christmas?",
    ],
  },
  {
    name: "Lisa Simpson",
    image: "https://upload.wikimedia.org/wikipedia/en/e/ec/Lisa_Simpson.png",
    quotes: [
      "I am the Lizard Queen!",
      "I'll overthrow society.",
      "There's only one thing to do: strut!",
    ],
  },
  {
    name: "Maggie Simpson",
    image: "https://upload.wikimedia.org/wikipedia/en/9/9d/Maggie_Simpson.png",
    quotes: ["*sucking sounds*", "*baby noises*", "*more sucking sounds*"],
  },
  {
    name: "Krusty the Clown",
    image: "https://upload.wikimedia.org/wikipedia/en/5/5a/Krustytheclown.png",
    quotes: [
      "Hey hey, kids!",
      "Not rich by signing checks.",
      "Not a role model... just naughty.",
    ],
  },
  {
    name: "Ned Flanders",
    image: "https://upload.wikimedia.org/wikipedia/en/8/84/Ned_Flanders.png",
    quotes: [
      "Okely-dokely!",
      "Feels like nothing at all!",
      "Done everything the Bible says.",
    ],
  },
  {
    name: "Mr. Burns",
    image: "https://upload.wikimedia.org/wikipedia/en/5/56/Mr_Burns.png",
    quotes: [
      "Excellent... Smithers.",
      "Money can buy happiness.",
      "Who shot who in the what now?",
    ],
  },
];
